<script>
  import { blocklist, text, richtext, image, url, submitMessage } from "../toolbox.js";
  import { link, links } from "svelte-routing";

  export let block;
</script>

<section id="contact" class="contact">
  <div class="container" data-aos="fade-up">
    <header class="section-header">
      <h2>{text(block, 'preheadline')}</h2>
      <p>{text(block, 'headline')}</p>
    </header>
    <div class="row gy-4">
      <div class="col-lg-6">
        <div class="row gy-4">
          {#each blocklist(block, 'contacts') as item}
          <div class="col-md-6">
            <div class="info-box">
              <img src="{image(item, 'icon', [50, 50])}" alt="">
              <h3>{text(item, 'title')}</h3>
              <p>{@html richtext(item, 'body')}</p>
            </div>
          </div>
          {/each}
        </div>
      </div>
      <div class="col-lg-6">
        <form on:submit={submitMessage} action="" method="post" class="php-email-form">
          <div class="row gy-4">
            <div class="col-md-6">
              <input type="text" name="name" class="form-control" placeholder="{text(block, 'nameField')}" required>
            </div>
            <div class="col-md-6 ">
              <input type="email" class="form-control" name="email" placeholder="{text(block, 'emailField')}" required>
            </div>
            <div class="col-md-12">
              <textarea class="form-control" name="msg" rows="6" placeholder="{text(block, 'messageField')}" required></textarea>
            </div>
            <div class="col-md-12 text-center">
              <button type="submit">{text(block, 'buttonName')}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
